<template>
  <svg class="svg" :width="ClientWidth" :height="ClientHeight">
    <g v-for="(item, index) in waterMarkMap">
      <text
        :opacity="opacity"
        :transform="`rotate(${gradient} 0,0)`"
        :text-anchor="fontPosition"
        :font-family="fontFamily"
        :font-size="fontSize"
        :id="`svg_${index}`"
        :x="item.x"
        :y="item.y"
        :fill="fontColor"
        class="text"
      >
        {{ waterMarkResult }}
      </text>
    </g>
  </svg>
</template>

<script type="text/ecmascript-6">
import { mapGetters } from 'vuex';
export default {
  name: 'water-mark',
  props: {
    width: {
      type: [Number, String]
    },
    height: {
      type: [Number, String]
    },
    /**
     * 水印配置，用于处理h5附件水印配置
     */
    waterMarkConfig: {
      type: Object,
    }
  },
  data() {
    return {
      waterMarkResult: '',                            //水印展示内容
      gradient: '-30',                                //倾斜度
      opacity: 0.12,                                    //水印透明度
      fontSize: 12,                                     //字体大小
      fontColor: '#70788F',                             //字体颜色
      fontFamily: 'PingFangSC-Regular, Helvetica, Arial, sans-serif',       //字体
      fontPosition: 'middle',                            //字体  左对齐 start  居中 middle  右对齐 end
      offsetHeight: 75,                                  //水印 上下行 间距
      waterMarkMap: [],
      currentTime: moment().format('YYYY/MM/DD HH:mm'),
      timer: 0,
      firstTimer: 0,
      options: [
        {
          key: 'UserName',
          reg: new RegExp('#UserName#', 'g'),
          target: 'fullName',
        },
        {
          key: 'EmpId',
          reg: new RegExp('#EmpId#', 'g'),
          target: 'employeeID',
        },
        {
          key: 'CurrentTime',
          reg: new RegExp('#CurrentTime#', 'g'),
        },
      ]
    };
  },
  watch: {
    getCompanyConfigurations() {
      this.updateText(true);
    },
    currentTime() {
      this.updateText();
    },
    getSelectedLanguage() {
      this.updateText(true);
    },
    waterMarkConfig: {
      handler: function (newVal, oldVal) {
        if (newVal) {
          this.updateText(true);
        }
      },
      deep: true,
      immediate: true
    },
  },
  computed: {
    ...mapGetters([
      'getUserInfo',
      'getSelectedLanguage',
      'getCompanyConfigurations'
    ]),
    ClientWidth() {
      return document.documentElement.clientWidth;
    },
    ClientHeight() {
      return document.documentElement.clientHeight;
    }
  },
  mounted() {
    const mountedSec = moment().seconds();
    const firstTimeOut = (60 - mountedSec) * 1000;
    this.firstTimer = setInterval(this.updateTime, firstTimeOut);
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = 0;
    }
  },
  methods: {
    //水印 单个 渲染的位置 map
    setSvgMap() {
      if(this.waterMarkResult && this.waterMarkResult.length !== 0) {
        let ClientWidth = document.documentElement.clientWidth;
        let ClientHeight = document.documentElement.clientHeight;
        let map = [];
        let basicWidth = (this.calculateLength(this.waterMarkResult)*12) + 24;
        let rowNum = Math.round(ClientWidth/basicWidth) + 1;
        let columnNum = Math.round((ClientHeight - this.fontSize)/75) + 1;
        for(let y = 0; y < columnNum; y++) {
          for(let x = 0; x < rowNum; x++) {
            //右上
            map.push({x: y%2 ? (x*basicWidth + basicWidth/2) : x*basicWidth, y: this.offsetHeight*y + 12});
            //左上
            map.push({x: -basicWidth - (y%2 ? (x*basicWidth - basicWidth/2) : x*basicWidth), y: this.offsetHeight*y + 12});
            //右下
            map.push({x: y%2 ? x*basicWidth : (x*basicWidth + basicWidth/2), y: ClientHeight + this.offsetHeight + this.offsetHeight*y});
            //左下
            map.push({x: -basicWidth - (y%2 ? x*basicWidth : (x*basicWidth - basicWidth/2)), y: ClientHeight + this.offsetHeight + this.offsetHeight*y});
          }
        }
        this.waterMarkMap = map;
      } else {
        this.waterMarkMap = [];
      }
    },
    calculateLength(str) {
      let len = 0;
      for(let i=0; i<str.length; i++) {
        if(str.charCodeAt(i)>256) {
          len += 2;
        } else {
          len++;
        }
      }
      return len;
    },
    updateTime() {
      this.currentTime = moment().format('YYYY/MM/DD HH:mm');
      if (this.firstTimer) {
        clearInterval(this.firstTimer);
        this.firstTimer = 0;
        this.timer = setInterval(this.updateTime, 60000);
      }
    },
    updateText(updateMap = false) {
      // 区分文本水印和附件水印，如果传入了waterMarkConfig，那么就自定义去处理
      let { waterMarkFlag, waterMarkContentDTOS = [] } = this.waterMarkConfig || this.getCompanyConfigurations || {};
      const target = Array.isArray(waterMarkContentDTOS) ? waterMarkContentDTOS.find((item) => item.language.toLowerCase() === this.getSelectedLanguage.toLowerCase()) : undefined;
      const nextTarget = Array.isArray(waterMarkContentDTOS) ? waterMarkContentDTOS.find((item) => item.content) : undefined;
      let text = (target && target.content) || (nextTarget && nextTarget.content) || '';
      if (waterMarkFlag) {
        this.options.map(({ reg, target }) => {
          text = text.replace(reg, target ? this.getUserInfo[target] : this.currentTime);
        });
        this.waterMarkResult = text;
        // 【1】以前的 canvas 的方法 模糊问题（缩放造成的，已解决） 其他就是 div 太大，切定位 是 % 定位 键盘调起 水印会移 任何 页面变化 都会有潜在的问题，所以 不要了
        // this.set(item.result);

        // 【2】新的 方法是用的 svg 矢量图 不用考虑 模糊问题（缩放造成的），且 svg div 就等于 屏幕宽高 不会有 div 比 屏幕大 N 倍的问题。
        if (updateMap) this.setSvgMap();
      }
    },
  }
};
</script>

<style scoped lang="scss">
@import '~assets/css/variable.scss';
.svg {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
  pointer-events: none;
}
</style>
